import DashboardLayout from "../components/DashboardLayout";
import { MERCHANT_NAV, MERCHANT_FOOTER_LINKS } from "../config/merchantNav";

const MerchantDashboardLayout = () => (
  <DashboardLayout
    navItems={MERCHANT_NAV}
    footerLinks={MERCHANT_FOOTER_LINKS}
    showVerificationBadge
    shellClassName="dashboard-shell--merchant"
  />
);

export default MerchantDashboardLayout;
